module.exports = __webpack_public_path__ + "static/media/jingteshu24.22f123ee.png";